import { colors } from '@aloft/toolkit-sui';
import { Font, Text as ReactPDFText, StyleSheet } from '@react-pdf/renderer';

Font.register({ family: 'Lato-Regular', src: '/Lato-Regular.ttf' });
Font.register({ family: 'Lato-Bold', src: '/Lato-Bold.ttf' });

const styles = StyleSheet.create({
  h1: {
    fontSize: 22,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  h2: {
    fontSize: 18,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
    marginBottom: '8px',
  },
  h3: {
    fontSize: 14,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
    marginBottom: '3px',
  },
  h4: {
    fontSize: 10,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  h5: {
    fontSize: 10,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  subtitle3: {
    fontSize: 10,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  body: {
    fontSize: 10,
    fontFamily: 'Lato-Regular',
    color: colors.textPrimary,
  },
  th: {
    fontSize: 10,
    fontFamily: 'Lato-Bold',
    color: colors.textPrimary,
  },
  td: {
    fontSize: 9,
    fontFamily: 'Lato-Regular',
    color: colors.textPrimary,
  },
  h6: {},
  subtitle1: {},
  subtitle2: {},
  body1: {
    fontSize: 10,
    fontFamily: 'Lato-Regular',
    color: colors.textPrimary,
    marginBottom: '10px',
  },
  body2: {
    fontSize: 9,
    fontFamily: 'Lato-Regular',
    color: colors.textSecondary,
    marginTop: '2px',
  },
  link: {},
  placeholder: {},
  buttonSmall: {},
  buttonRegular: {},
  chip: {},
  tableColumnTitle: {},
  tableH1: {},
  tableH2: {},
  tableH3: {},
  tableTag: {},
  displayLarge: {},
  displayMedium: {},
  displaySmall: {},
  label: {},
  underlined: {
    textDecoration: 'underline',
    textDecorationColor: colors.alertError,
    textDecorationStyle: 'dotted',
  },
});

type Props = {
  children: string;
  variant?: keyof typeof styles;
  marginTop?: string;
  underlined?: boolean;
  textAlign?: 'left' | 'center' | 'right';
};

export const Text = ({ variant = 'h2', marginTop, underlined, children, textAlign }: Props) => (
  <ReactPDFText
    style={[
      styles[variant],
      { marginTop },
      underlined ? styles.underlined : {},
      textAlign ? { textAlign } : {},
    ]}
  >
    {children}
  </ReactPDFText>
);
